import { useNextTranslation } from "../../hooks";
import { ProductBookNowButton, ProductBookNowButtonProps } from "../../product/ProductBookNowButton";
import type { ExternalWidgetBookingkit as ExternalWidgetBookingkitType } from "../../types/ExternalWidget";

export type ExternalWidgetBookingkitProps = Omit<ExternalWidgetBookingkitType, "__typename"> & {
    ButtonComponent?: (props: ProductBookNowButtonProps) => JSX.Element;
    onOpen?: () => void;
};

export function ExternalWidgetBookingkit({ subdomain, ButtonComponent, onOpen }: ExternalWidgetBookingkitProps) {
    const [t] = useNextTranslation("externalWidget");
    const Button = ButtonComponent ?? ProductBookNowButton;

    return (
        <Button onClick={onOpen} data-button-text={t("bookingkit.availabilityButton.dataText")} disabled={!subdomain}>
            {t("bookingkit.availabilityButton.label")}
        </Button>
    );
}
